<ng-container *transloco="let t; read: 'absenceGroups'">
  <h1 class="mbm">{{ t("admin-title") }}</h1>

  <kendo-tabstrip *ngIf="ready">
    <kendo-tabstrip-tab [title]="t('myTab')" [selected]="true">
      <ng-template kendoTabContent>
        <app-my-absences></app-my-absences>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab *ngIf="canReview">
      <ng-template kendoTabTitle>
        {{ t('reviewTab') }}
        <span *ngIf="reviewCount" class="count-circle mls">{{ reviewCount }}</span>
      </ng-template>
      <ng-template kendoTabContent>
        <app-absence-review></app-absence-review>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab [title]="t('allTab')">
      <ng-template kendoTabContent>
        <app-all-absences [canViewList]="canViewTeamList"></app-all-absences>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</ng-container>
